<template>
  <div class="map">
    <div style="width: 100%; height: 100%" id="dituContent"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {
    this.getMap();
  },
  methods: {
    getMap() {
      //创建和初始化地图函数：
      function initMap() {
        createMap(); //创建地图
        setMapEvent(); //设置地图事件
        addMapControl(); //向地图添加控件
        addMarker(); //向地图中添加marker
      }

      //创建地图函数：
      function createMap() {
        var map = new BMapGL.Map("dituContent"); //在百度地图容器中创建一个地图
        var point = new BMapGL.Point(113.457399, 23.10241); //定义一个中心点坐标
        map.centerAndZoom(point, 18); //设定地图的中心点和坐标并将地图显示在地图容器中
        window.map = map; //将map变量存储在全局
      }

      //地图事件设置函数：
      function setMapEvent() {
        map.enableDragging(); //启用地图拖拽事件，默认启用(可不写)
        map.enableScrollWheelZoom(); //启用地图滚轮放大缩小
        map.enableDoubleClickZoom(); //启用鼠标双击放大，默认启用(可不写)
        map.enableKeyboard(); //启用键盘上下左右键移动地图
      }

      //地图控件添加函数：
      function addMapControl() {}
      //标注点数组 广东省广州市黄埔区港湾路68号中交港湾国际大厦20楼
      var markerArr = [
        {
          title: "货运江湖",
          content: "广州市黄埔区港湾路68号2016",
          point: "113.457399|23.10241",
          isOpen: 1,
          icon: { w: 23, h: 25, l: 46, t: 21, x: 9, lb: 12 },
        },
      ];
      //创建marker
      function addMarker() {
        for (var i = 0; i < markerArr.length; i++) {
          var json = markerArr[i];
          var p0 = json.point.split("|")[0];
          var p1 = json.point.split("|")[1];
          var point = new BMapGL.Point(p0, p1);
          var iconImg = createIcon(json.icon);
          var marker = new BMapGL.Marker(point, { icon: iconImg });
          var iw = createInfoWindow(i);
          var label = new BMapGL.Label(json.title, {
            offset: new BMapGL.Size(json.icon.lb - json.icon.x + 10, -20),
          });
          marker.setLabel(label);
          map.addOverlay(marker);
          label.setStyle({
            borderColor: "#808080",
            color: "#333",
            cursor: "pointer",
          });

          (function () {
            var index = i;
            var _iw = createInfoWindow(i);
            var _marker = marker;
            _marker.addEventListener("click", function () {
              this.openInfoWindow(_iw);
            });
            _iw.addEventListener("open", function () {
              _marker.getLabel().hide();
            });
            _iw.addEventListener("close", function () {
              _marker.getLabel().show();
            });
            label.addEventListener("click", function () {
              _marker.openInfoWindow(_iw);
            });
            if (!!json.isOpen) {
              label.hide();
              _marker.openInfoWindow(_iw);
            }
          })();
        }
      }
      //创建InfoWindow
      function createInfoWindow(i) {
        var json = markerArr[i];
        var iw = new BMapGL.InfoWindow(
          "<b class='iw_poi_title' title='" +
            json.title +
            "'>" +
            json.title +
            "</b><div class='iw_poi_content'>" +
            json.content +
            "</div>"
        );
        return iw;
      }
      //创建一个Icon
      function createIcon(json) {
        var icon = new BMapGL.Icon(
          "http://api.map.baidu.com/lbsapi/creatmap/images/us_mk_icon.png",
          new BMapGL.Size(json.w, json.h),
          {
            imageOffset: new BMapGL.Size(-json.l, -json.t),
            infoWindowOffset: new BMapGL.Size(json.lb + 5, 1),
            offset: new BMapGL.Size(json.x, json.h),
          }
        );
        return icon;
      }

      initMap(); //创建和初始化地图
    },
  },
};
</script>
<style scoped="scoped">
/*  */
.map {
  width: 100%;
  height: 325px;
}
.iw_poi_title {
  color: #cc5522;
  font-size: 14px;
  font-weight: bold;
  overflow: hidden;
  padding-right: 13px;
  white-space: nowrap;
}
.iw_poi_content {
  font: 12px arial, sans-serif;
  overflow: visible;
  padding-top: 4px;
  white-space: -moz-pre-wrap;
  word-wrap: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/map.vue